import { Component } from "@angular/core";
import { AuthService } from "./services/auth.service";
import packageJson from "../../package.json";
import { NgIf } from "@angular/common";
import { RouterLink, RouterOutlet } from "@angular/router";
import { DebugContainerComponent } from "./debug-container/debug-container.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [NgIf, RouterLink, RouterOutlet, DebugContainerComponent]
})
export class AppComponent {
  title = "prior-auth-facade";
  showLogContent = true;
  version = `FACADE V${packageJson.version}`;

  constructor(private readonly authService: AuthService) {}

  showLogs() {
    // store in session?
    this.showLogContent = !this.showLogContent;
  }

  loggedIn() {
    return this.authService.isLoggedIn();
  }

  logout() {
    this.authService.logout();
  }
}
